import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pa-md" }

import { unix } from 'dayjs';


export default /*#__PURE__*/_defineComponent({
  __name: 'Transactions',
  props: { transactions: Array },
  setup(__props) {

const props = __props



console.log('props', props)
const cashFieldCallback =(t: any) => { 
  var cash = (t.Cash / 100) + "$"
  cash += t.Cash > 0 ? " 🟩" : " 🟥"
  return cash
}
const columns: Array<any> = [
  { name: 'cash', align: 'left', label: 'Cash', field: cashFieldCallback, sortable: true },
  { name: 'gems', label: 'Gems', field: (t: any) => t.Gems, sortable: true },
  { name: 'timestamp', label: 'Date', field: (t: any) => unix(t.Timestamp ?? 0).format('DD/MM/YYYY HH:mm:ss'), sortable: true },
  { name: 'type', label: 'Type', field: (t: any) => t.Type ?? t.Description }
]

return (_ctx: any,_cache: any) => {
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_table, {
      title: "Transactions 📖",
      rows: props.transactions,
      columns: columns,
      "row-key": "name"
    }, null, 8, ["rows"])
  ]))
}
}

})